import responseService from "../../services/responseService";

const state = {
  charts: []
};

const getters = {
  charts: state => {
    return state.charts;
  }
};

const actions = {
  fetchData({ commit }) {
    responseService.fetchResponses().then(response => {
      commit("updateCharts", response.data);
    });
  }
};

const mutations = {
  updateCharts(state, chartData) {
    state.charts = chartData;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
